<template>
  <div class="rounded-lg bg-white mt-2 mx-4 w-[calc(100%-2rem)]">
    <van-form class="">
      <!-- 邮寄地址 -->
      <div v-if="showAddress">
        <van-field
          class="px-3"
          v-model="form.receiverCountry"
          :label="$t('address.country')"
          :placeholder="$t('address.countryPlaceholder')"
          readonly
          is-link
          @click-input="handleCountryClick" />
        <van-field
          class="px-3"
          v-model="form.receiverCity"
          :label="$t('address.city')"
          :placeholder="$t('address.cityPlaceholder')"
          readonly
          is-link
          @click-input="handleCityClick" />
        <van-field
          class="px-3"
          v-model="form.receiverZipcode"
          :label="$t('address.zipCode')"
          label-width="100px"
          :placeholder="$t('address.zipCodePlaceholder')" />

        <van-field
          label-width="140"
          v-model="form.address"
          :label="$t('products.shippingAddress')"
          :placeholder="$t('products.shippingAddressPlaceholder')"
          class="px-3" />
      </div>
      <van-field
        label-width="140"
        v-model="form.name"
        :label="$t('products.recipient')"
        :placeholder="$t('products.recipientPlaceholder')"
        class="px-3" />

      <van-field
        label-width="120px"
        v-model="form.mobile"
        :label="$t('address.phone')"
        :placeholder="$t('address.phoneNumberPlaceholder')"
        class="px-3">
        <template #input>
          <div class="flex-1 flex items-center justify-end">
            <div>
              <van-field
                v-model="form.countryCode"
                :placeholder="$t('address.countryCodePlaceholder')"
                class="p-0"
                readonly
                is-link
                @click-input="showCountryCodePopup = true" />
            </div>
            <van-field v-model="form.mobile" :placeholder="$t('address.phoneNumberPlaceholder')" class="p-0 w-44" />
          </div>
        </template>
      </van-field>
      <!-- 邮箱 -->
      <van-field
        label-width="140"
        v-model="form.email"
        @input="handleEmailInput"
        :label="$t('products.emailAddress')"
        placeholder="XXXX@gmail.com"
        class="px-3" />

      <div class="px-3 py-2">
        <van-checkbox v-model="form.subscribeMarketing" class="text-sm" icon-size="1rem" checked-color="#ff7a00">
          {{ $t("products.subscribeMarketing") }}
        </van-checkbox>
      </div>

      <div class="" v-if="!isLoggedIn">
        <div v-if="isZh && isRegister == false && form.email" class="tip-row flex items-center text-sm mb-1 px-3 py-2">
          <span>{{ $t("products.nonMember") }}</span>
          <van-button class="ml-1" type="primary" size="mini" plain color="#ff7a00" @click="handleRegister">
            {{ $t("products.oneClickRegister") }}
          </van-button>
          <span class="ml-1">{{ $t("products.getRm5Coupon") }}{{ newReward || 0 }}{{ $t("products.getRm5Coupon2") }}</span>
        </div>
        <div v-else-if="!isZh && isRegister == false && form.email" class="tip-row text-sm mb-1 px-3 py-2">
          <div>{{ $t("products.nonMember") }}</div>
          <div class="flex items-center">
            <van-button type="primary" size="mini" plain color="#ff7a00" @click="handleRegister">
              {{ $t("products.oneClickRegister") }}
            </van-button>
            <div class="ml-1">{{ $t("products.getRm5Coupon") }}{{ newReward || 0 }}{{ $t("products.getRm5Coupon2") }}</div>
          </div>
        </div>

        <!-- 已注册 立即登录 -->
        <div class="tip-row flex items-center text-sm px-3 py-2" v-if="isRegister && form.email">
          <span>{{ $t("products.loginEarnCoins") }}</span>
          <van-button class="ml-1" type="primary" size="mini" plain color="#ff7a00" @click="handleLogin">
            {{ $t("products.oneClickLogin") }}
          </van-button>
        </div>
      </div>
    </van-form>
    <!-- 国家选择弹窗 -->
    <van-popup v-model="showCountryPopup" position="bottom">
      <van-picker show-toolbar :columns="countryList" @confirm="onCountryConfirm" @cancel="showCountryPopup = false" />
    </van-popup>

    <!-- 城市选择弹窗 -->
    <van-popup v-model="showCityPopup" position="bottom">
      <van-picker show-toolbar :columns="cityList" @confirm="onCityConfirm" @cancel="showCityPopup = false" />
    </van-popup>

    <!-- 区号弹窗 -->
    <van-popup v-model="showCountryCodePopup" position="bottom">
      <van-picker show-toolbar :columns="countryCodeList" @confirm="onCountryCodeConfirm" @cancel="showCountryCodePopup = false">
        <template v-slot:option="slotProps">
          <div class="flex items-center text-sm">
            <img :src="slotProps.icon" class="w-5 h-auto" alt="" />
            <span class="ml-3">{{ slotProps.text }}</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { Form, Checkbox, Popup, Picker } from "vant"
import { checkRegister } from "@/apis/pay"
import { getNewReward, getAddressCountryList, getCityList } from "@/apis/shop"
import { debounce } from "@/utils/common"
import { mapMutations, mapGetters } from "vuex"

export default {
  name: "AddressForm",
  components: {
    [Form.name]: Form,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  data() {
    return {
      form: {
        address: "",
        name: "",
        mobile: "",
        email: "",
        areaCode: "",
        subscribeMarketing: false,
        receiverCountry: "",
        receiverCity: "",
        receiverZipcode: "",
        countryMark: "",
        countryCode: "",
      },
      isRegister: null,
      newReward: 0,
      countryList: [],
      cityList: [],
      countryCodeList: [
        {
          text: "+86",
          value: "86",
          country: "中国",
          icon: "https://flagcdn.com/w40/cn.png",
        },
        {
          text: "+65",
          value: "65",
          country: "新加坡",
          icon: "https://flagcdn.com/w40/sg.png",
        },
        {
          text: "+60",
          value: "60",
          country: "马来西亚",
          icon: "https://flagcdn.com/w40/my.png",
        },
        {
          text: "+66",
          value: "66",
          country: "泰国",
          icon: "https://flagcdn.com/w40/th.png",
        },
        {
          text: "+62",
          value: "62",
          country: "印尼",
          icon: "https://flagcdn.com/w40/id.png",
        },
        {
          text: "+63",
          value: "63",
          country: "菲律宾",
          icon: "https://flagcdn.com/w40/ph.png",
        },
        {
          text: "+84",
          value: "84",
          country: "越南",
          icon: "https://flagcdn.com/w40/vn.png",
        },
        {
          text: "+95",
          value: "95",
          country: "缅甸",
          icon: "https://flagcdn.com/w40/mm.png",
        },
        {
          text: "+855",
          value: "855",
          country: "柬埔寨",
          icon: "https://flagcdn.com/w40/kh.png",
        },
        {
          text: "+673",
          value: "673",
          country: "文莱",
          icon: "https://flagcdn.com/w40/bn.png",
        },
        {
          text: "+886",
          value: "886",
          country: "台湾",
          icon: "https://flagcdn.com/w40/tw.png",
        },
        {
          text: "+852",
          value: "852",
          country: "香港",
          icon: "https://flagcdn.com/w40/hk.png",
        },
      ],
      showCountryPopup: false,
      showCityPopup: false,
      showCountryCodePopup: false,
    }
  },
  created() {
    // 创建防抖函数实例
    this.debouncedCheckRegister = debounce((value) => {
      if (!value || !value.includes(".")) return

      checkRegister({ email: value })
        .then((res) => {
          this.isRegister = res.data
          this.$emit("register-check", res.data)
        })
        .catch((err) => {
          console.log("checkRegister error :>> ", err)
        })
    }, 1000)
    this.getCountryList()
  },
  props: {
    addressData: {
      type: Object,
      default: () => ({}),
    },
    showAddress: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
      userInfo: "auth/userInfo",
    }),
  },
  methods: {
    ...mapMutations({
      setLoginDialogVisible: "auth/SET_LOGIN_DIALOG_VISIBLE",
      setRegisterDialogVisible: "auth/SET_REGISTER_DIALOG_VISIBLE",
    }),
    fetchNewReward() {
      getNewReward()
        .then((res) => {
          this.newReward = res.data
          console.log("this.newReward :>> ", this.newReward)
        })
        .catch((err) => {
          console.log("getCouponList error :>> ", err)
        })
    },
    onSubmit(values) {
      console.log("表单提交:", values)
      this.$emit("form-submit", values)
    },
    handleRegister() {
      this.setRegisterDialogVisible(true)
    },
    handleLogin() {
      this.setLoginDialogVisible(true)
    },
    getFormData() {
      return this.form
    },
    validateForm() {
      if (this.showAddress) {
        return (
          this.form.address &&
          this.form.receiverCountry &&
          this.form.receiverCity &&
          this.form.receiverZipcode &&
          this.form.name &&
          this.form.mobile &&
          this.form.email &&
          this.form.countryCode
        )
      } else {
        return this.form.email
      }
    },
    handleEmailInput(value) {
      // 使用组件实例上的防抖函数
      !this.isLoggedIn && this.debouncedCheckRegister(value)
    },
    handleCountryClick() {
      if (this.countryList.length === 0) {
        this.getCountryList()
      }
      this.showCountryPopup = true
    },
    handleCityClick() {
      if (!this.form.countryMark) {
        return
      }
      if (this.cityList.length === 0 && this.form.countryMark) {
        this.getCityList(this.form.countryMark)
      }
      this.showCityPopup = true

    },
    async getCountryList() {
      try {
        const response = await getAddressCountryList()
        console.log("response :>> ", response)
        const data = response.data
        this.countryList = data.map((item) => {
          // const name = this.isZh ? item.name : item.nameEn
          // if (name === this.form.country) {
          //   this.form.countryMark = item.mark
          // }
          return {
            text: this.isZh ? item.name : item.nameEn,
            value: item.mark,
          }
        })
      } catch (error) {}
    },
    async getCityList(country) {
      try {
        const response = await getCityList({ country })
        const data = response.data
        this.cityList = data.map((item) => {
          return {
            text: this.isZh ? item.name : item.nameEn,
            value: this.isZh ? item.name : item.nameEn,
          }
        })
      } catch (error) {}
    },
    onCountryConfirm(value) {
      this.form.receiverCountry = value.text
      this.form.receiverCity = ""
      this.$emit("address-click", { receiverCity: this.form.receiverCity, receiverCountry: this.form.receiverCountry })
      this.$set(this.form, "countryMark", value.value)

      this.showCountryPopup = false
    },
    onCityConfirm(value) {
      this.form.receiverCity = value.text
      this.$emit("address-click", { receiverCity: this.form.receiverCity, receiverCountry: this.form.receiverCountry })
      this.showCityPopup = false
    },
    onCountryCodeConfirm(value) {
      this.$set(this.form, "countryCode", value.text)
      this.showCountryCodePopup = false
    },
  },
  watch: {
    addressData: {
      handler(newVal) {
        console.log("this.userInfo :>> ", this.userInfo)
        const mobile = newVal.mobile || this.userInfo.mobile
        const match = mobile.match(/^\+(\d+)\s*(.+)$/)
        this.form = {
          address: newVal.detailAddress,
          receiverCountry: newVal.country,
          receiverCity: newVal.city,
          receiverZipcode: newVal.zipCode,
          countryCode: match ? "+" + match[1] : "",
          name: newVal.name,
          mobile: match ? match[2] : mobile,
          subscribeMarketing: newVal.subscribeMarketing,
          countryMark: newVal.countryMark,
          email: this.userInfo.email,
        }
      },
      deep: true,
    },
    "form.countryMark": {
      handler(newVal) {
        newVal && this.getCityList(newVal)
      },
    },
    isRegister: {
      handler(newVal) {
        // console.log('newVal :>> ', newVal);
        if (newVal === false && !this.newReward) {
          this.fetchNewReward()
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
/deep/.van-field__control {
  text-align: right;
}
</style>
